import React from 'react';
import Lazyload from 'react-lazyload';
import { MemberShape } from 'utils/shapes';
import ArenaItemPreview from 'components/arena/ArenaItemPreview';
import ArenaIcon from 'components/arena/ArenaIcon';
import { gettext } from 'utils/text';

const ArenaMemberItem = ({ item }) => (
    <div className="arena__item arena__item--member">
        <a href={item.user.link}>
            <Lazyload height={item.content_preview.height} once>
                <ArenaItemPreview title={item.user.name} itemContent={item.content_preview} />
            </Lazyload>
        </a>
        <div className="arena__item__meta">
            <a href={item.user.link}>
                <h4 className="arena__item__title mb-0">{item.user.name}</h4>
                <time className="arena__item__member__joined">
                    {gettext('Joined')} {item.user.date_joined}
                </time>
            </a>
            <div className="arena__item__bottom">
                <div className="arena__item__bottom__left arena__item__bottom__left--member">
                    <div className="arena__item__member">
                        {item.age ? (
                            <div className="arena__item__member__age">
                                {item.age} {gettext('years old')}
                            </div>
                        ) : undefined}
                    </div>
                    {item.user.consultant && item.user.consultant.cat ? (
                        <div className="arena__item__member__mentor">
                            {gettext('Mentor: ')}
                            {item.user.consultant.cat.map((category) => category.name).join(', ')}
                        </div>
                    ) : null}
                </div>
                <div className="arena__item__bottom__right arena__item__bottom__right--member">
                    <a href={`${item.user.link}#public_p`}>
                        <ArenaIcon iconName="comment" number={item.number_of_public_comments} />
                    </a>
                    <a href={`${item.user.link}#arena-wrapper`}>
                        <ArenaIcon iconName="folder--upload" number={item.number_of_public_uploads} />
                    </a>
                </div>
            </div>
        </div>
    </div>
);

ArenaMemberItem.propTypes = {
    item: MemberShape.isRequired,
};

export default ArenaMemberItem;



// WEBPACK FOOTER //
// ./src/components/medlemmer/ArenaMemberItem.js